import { connect } from "react-redux";

import { userSelectsViewType } from "../actions/view_type";
import ViewType from "../components/view_type";

const mapStateToProps = (state) => {
  return {
    selectedPrimaryTypeId: state.filters.primaryFilter.selectedTypeId,
    selectedViewTypeId: state.filters.viewType.id,
    selectedOptions: state.filters.primaryFilter.selectedOptions || []
  };
};

const mapDispatchToProps = dispatch => ({
  onChange: (e) => { dispatch(userSelectsViewType(e)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewType);
